import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EstimateActualFareCalulation } from '../../trip-fare-adjustment-detail/trip-fare-adjustment-detail.component';

@Component({
  selector: 'app-fare-and-rates-details-dialog',
  templateUrl: './fare-and-rates-details-dialog.component.html',
  styleUrls: ['./fare-and-rates-details-dialog.component.scss']
})
export class FareAndRatesDetailsDailogComponent {
  constructor(
    private dialogRef: MatDialogRef<FareAndRatesDetailsDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EstimateActualFareCalulation
  ) {}

  close() {
    this.dialogRef.close();
  }
}
